import { useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import axios from "axios";
import { toast } from "sonner";
import { useStore } from "../context/StoreContext";
import { AL, inputCls, btn, errMsg } from "../components/account/shared";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export default function ResetPassword() {
  const { lang } = useStore();
  const l = AL[lang].login;
  const [params] = useSearchParams();
  const [pw, setPw] = useState("");
  const [done, setDone] = useState(false);
  const submit = async (e) => {
    e.preventDefault();
    try { await axios.post(`${API}/auth/reset-password`, { token: params.get("token") || "", password: pw }); setDone(true); }
    catch (err) { toast.error(errMsg(err, l.invalid)); }
  };
  return (
    <div className="min-h-screen pt-32 pb-24 px-6 flex justify-center" data-testid="reset-page">
      <div className="w-full max-w-md">
        <p className="text-[11px] font-mono uppercase tracking-[0.3em] text-[#C85A32] mb-3">NŪRA</p>
        <h1 className="font-serif text-4xl text-stone-900 mb-8">{l.resetTitle}</h1>
        {done ? <p className="text-sm text-stone-700" data-testid="reset-done">{l.resetDone} <Link to="/compte" className="underline">→</Link></p> : (
          <form onSubmit={submit} className="space-y-4">
            <input data-testid="reset-password" required minLength={8} type="password" className={inputCls} placeholder="••••••••" value={pw} onChange={(e) => setPw(e.target.value)} />
            <button data-testid="reset-submit" className={`${btn} w-full justify-center py-4`}>{l.resetTitle}</button>
          </form>
        )}
      </div>
    </div>
  );
}
